/**
 * Texte, die an mehr als einer Stelle stehen — Knöpfe, Zustände, Bestätigungen.
 *
 * Bewusst klein gehalten: Ein Wort, das in zwei Zusammenhängen dasselbe heißt,
 * gehört hierher; eines, das nur zufällig gleich klingt, nicht. „Speichern" ist
 * überall Speichern, „Fertig" ist es nicht.
 */
export const common = {
    'common.cancel': 'Abbrechen',
    'common.save': 'Speichern',
    'common.close': 'Schließen',
    'common.delete': 'Löschen',
    'common.remove': 'Entfernen',
    'common.rename': 'Umbenennen',
    'common.back': 'Zurück',
    'common.moment': 'Einen Moment …',
    'common.loading': 'Lade …',
    'common.name': 'Name',
    'common.email': 'E-Mail',
    'common.password': 'Passwort',
    'common.organisation': 'Organisation',
    'common.yes': 'Ja',
    'common.no': 'Nein',
    'common.copy': 'Kopieren',
    'common.copied': 'Kopiert',
    'common.apply': 'Einsetzen',
    'common.unknownPerson': 'Unbekannte Person',
    'common.none': 'Keine',
    'common.person.one': '{count} Person',
    'common.person.many': '{count} Personen',
    'common.day.one': '{count} Tag',
    'common.day.many': '{count} Tage',
    'common.footer': 'Præsto — ein Werkzeug von',
    'legal.start': 'Startseite',
    'legal.imprint': 'Impressum',
    'legal.privacy': 'Datenschutz',
    'common.language': 'Sprache',
    'update.notice': 'Præsto wurde aktualisiert. Dieser Tab läuft noch auf dem alten Stand — bitte neu laden, sonst kann das Einfügen von Inhalten fehlschlagen.',
    'update.reload': 'Neu laden',
    'error.requestFailed': 'Anfrage fehlgeschlagen ({status})',
};
//# sourceMappingURL=common.js.map